import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormikField } from "@air/formik-field";
import { Button } from "@air/primitive-button";
import { Input } from "@air/primitive-input";
import { Modal, ModalCloseButton, ModalTitle } from "@air/primitive-modal";
import { useToasts } from "@air/provider-toast";
import { Form, Formik } from "formik";
import { useUpdateAssetTitle } from "~/swr-hooks/clips/useUpdateAssetTitle";
export const RenameClipsModal = (param)=>{
    let { clip, onClose } = param;
    const { updateAssetTitle } = useUpdateAssetTitle();
    const { showToast } = useToasts();
    var _clip_title;
    const currentClipTitle = (_clip_title = clip.title) !== null && _clip_title !== void 0 ? _clip_title : clip.importedName;
    return /*#__PURE__*/ _jsxs(Modal, {
        isOpen: true,
        onDismiss: onClose,
        children: [
            /*#__PURE__*/ _jsxs("header", {
                className: "mb-3 flex items-center justify-between",
                children: [
                    /*#__PURE__*/ _jsx(ModalTitle, {
                        children: "Rename asset"
                    }),
                    /*#__PURE__*/ _jsx(ModalCloseButton, {
                        className: "shrink-0",
                        onClick: onClose
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Formik, {
                initialValues: {
                    name: currentClipTitle
                },
                onSubmit: (param)=>{
                    let { name } = param;
                    updateAssetTitle(clip.id, name, clip.assetId);
                    showToast("Renamed ".concat(currentClipTitle, " to ").concat(name));
                    onClose();
                },
                children: /*#__PURE__*/ _jsxs(Form, {
                    children: [
                        /*#__PURE__*/ _jsx(FormikField, {
                            component: /*#__PURE__*/ _jsx(Input, {
                                required: true,
                                size: "large"
                            }),
                            id: "name",
                            label: "Asset name",
                            name: "name"
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "-mx-6 -mb-6 flex justify-end gap-3 px-6 py-4",
                            children: [
                                /*#__PURE__*/ _jsx(Button, {
                                    appearance: "ghost",
                                    color: "grey",
                                    onClick: onClose,
                                    size: "large",
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ _jsx(Button, {
                                    appearance: "filled",
                                    color: "blue",
                                    size: "large",
                                    type: "submit",
                                    children: "Save"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
